import Image from 'next/image';
import { useMemo } from 'react';

import { Badge, KeyValueRow, KeyValueTable } from '@/design-system/components/ui';

import { FogoLendStrategy, Trigger } from '../../domain';

interface Props {
  trigger: Trigger;
}

export function FogoLendTriggerFullDetails({ trigger }: Props) {
  const strategyLabel = useMemo(() => {
    const strategy = trigger.context?.strategy;
    return strategy === FogoLendStrategy.Deposit ? 'Deposit' : strategy === FogoLendStrategy.Borrow ? 'Borrow' : '-';
  }, [trigger.context]);

  const networkDisplay = useMemo(() => {
    return (
      <div className="tw:flex tw:flex-row tw:items-center tw:gap-2">
        <Image src="/assets/webp/fogo.webp" alt="Fogo" width={20} height={20} />
        <span>Fogo</span>
      </div>
    );
  }, []);

  const strategyDisplay = useMemo(() => {
    if (strategyLabel === '-') return '-';

    const color = strategyLabel === 'Deposit' ? 'success' : 'warning';

    return <Badge variant={color}>{strategyLabel}</Badge>;
  }, [strategyLabel]);

  const marketDisplay = useMemo(() => {
    return trigger.context?.market || 'all';
  }, [trigger.context]);

  return (
    <KeyValueTable>
      <KeyValueRow label="Name" value={trigger.name} />
      <KeyValueRow label="Description" value={trigger.description} />
      <KeyValueRow label="Network" value={networkDisplay} />
      <KeyValueRow label="Strategy" value={strategyDisplay} />
      <KeyValueRow label="Market" value={marketDisplay} />
      <KeyValueRow label="Argument conditions" value={trigger.conditionExpression ?? '-'} />
    </KeyValueTable>
  );
}
